export const submitRecaptcha = async (siteKey: string): Promise<string> => {
	return new Promise<string>((resolve, reject) => {
		if (!siteKey) {
			reject(new Error('Invalid reCAPTCHA token'));
			return;
		}

		if (typeof grecaptcha !== 'undefined' && grecaptcha.ready) {
			grecaptcha.ready(() => {
				grecaptcha
					.execute(siteKey, { action: 'submit' })
					.then((token: string) => {
						if (typeof token === 'string') {
							resolve(token);
						} else {
							reject(new Error('Invalid reCAPTCHA token'));
						}
					})
					.catch((error: Error) => {
						reject(new Error(`reCAPTCHA execution failed: ${error.message || error}`));
					});
			});
		} else {
			reject(new Error('reCAPTCHA not available. Please try again later.'));
		}
	});
};
